import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, Container, Typography, Button, Paper } from "@mui/material";
import { ArrowForward, School } from "@mui/icons-material";

const WelcomeScreen = () => {
  const navigate = useNavigate();
  const { user, isFirstLogin, consentRequired } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    if (!isFirstLogin && !consentRequired) {
      navigate("/dashboard");
    }
  }, [isFirstLogin, consentRequired, navigate]);

  const handleContinue = () => {
    if (consentRequired) {
      navigate("/consent");
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={6}
          sx={{
            p: 6,
            textAlign: "center",
            borderRadius: 4,
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              bgcolor: "primary.main",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mx: "auto",
              mb: 3,
            }}
          >
            <School sx={{ fontSize: 40, color: "white" }} />
          </Box>

          <Typography variant="h3" fontWeight={700} gutterBottom>
            Welcome, {user?.firstName}!
          </Typography>

          <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
            We're glad to have you here. Let's get you started with the ERP
            Admin Panel.
          </Typography>

          <Box sx={{ mb: 4 }}>
            <Typography variant="body1" color="text.secondary" paragraph>
              As a <strong>{user?.role?.name || "User"}</strong>, you have
              access to various features to help you manage your educational
              activities efficiently.
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              justifyContent: "center",
              mb: 4,
            }}
          >
            {[
              "View & Manage Profile",
              "Access Dashboard",
              "Check Notifications",
              "Communicate via Chat",
            ].map((feature, index) => (
              <Box
                key={index}
                sx={{
                  px: 3,
                  py: 1.5,
                  bgcolor: "grey.100",
                  borderRadius: 2,
                }}
              >
                <Typography variant="body2">{feature}</Typography>
              </Box>
            ))}
          </Box>

          <Button
            variant="contained"
            size="large"
            onClick={handleContinue}
            endIcon={<ArrowForward />}
            sx={{ px: 6, py: 1.5 }}
          >
            Get Started
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default WelcomeScreen;
